<template>
  <div
    v-if="isVisible"
    class="sato-banner"
  >
    <div class="sato-content">
      <div class="sato-brand-section">
        <img
          class="reelables-logo"
          :src="logo"
          :height="40"
          alt="Reelables logo"
        >
        <img
          src="https://www.scansource.com/~/media/Project/scansource/scansourceweb/Logos/Brand-Logos/sato_logo.png?h=222&iar=0&w=1200"
          alt="Sato Logo"
          class="sato-logo"
        >
        <div class="sato-text">
          <p>
            <strong>SEE IT. <span class="highlight-text">SCAN IT.</span> TRACK IT.</strong>
          </p>
          <p
            v-if="boothNumber"
            class="booth-text"
          >
            {{ boothNumber }}
          </p>
        </div>
      </div>

      <div class="sato-actions">
        <span
          v-if="boothNumber"
          class="booth-badge"
        >{{ boothNumber }}</span>
        <button
          v-if="hasButton"
          class="banner-button"
          @click="clickButton"
        >
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import LogoImage from '../../../assets/images/reelables-r-logo-white.svg';

export default {
  name: 'ModexBanner',
  props: {
    boothNumber: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isVisible: true,
    };
  },
  computed: {
    logo() {
      return LogoImage;
    },
    hasButton() {
      return !!this.buttonText;
    },
  },
  methods: {
    clickButton() {
      this.$emit('button-click');
    },
  },
};
</script>

<style scoped lang="scss">
.sato-banner {
  position: absolute;
  top: 0;
  background: linear-gradient(90deg, #022761 0%, #092B75 100%);
  color: #ffffff;
  padding: 8px;
  border-bottom: 3px solid #0283C6; /* Gold accent border */
  font-family: 'Helvetica-Neue', Arial, sans-serif;
  width: 100%;
  z-index: 10;
}

.sato-content {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sato-brand-section {
  display: flex;
  align-items: center;
  gap: 20px;
}

.sato-logo {
  height: 30px; /* Adjust height as needed */
  width: auto;
  filter: brightness(0) invert(1); /* Forces logo to be white for better contrast */
  margin-left: -8px;
}

.reelables-logo {
  margin-left: -8px;
}

.sato-text p {
  margin: 0;
  font-size: 20px;
  .highlight-text {
    color: #0283CB;
  }
}

.details {
  display: block;
  font-size: 12px;
  color: #cbd5e0;
}

.sato-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.booth-text {
  display: none;
}

.booth-badge {
  background-color: #0283C6;
  color: #000;
  padding: 3px 8px;
  font-weight: bold;
  font-size: 12px;
  border-radius: 2px;
}

.banner-button {
  background-color: #ffffff;
  color: #002e5d;
  padding: 6px 14px;
  text-decoration: none;
  font-weight: bold;
  font-size: 13px;
  border-radius: 4px;
  transition: 0.2s ease-in-out;
}

.banner-button:hover {
  background-color: #0283C6;
  color: #ffffff;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .sato-logo {
    height: 25px;
  }
  .details {
    display: inline;
    margin-left: 5px;
  }
  .sato-text p {
    font-size: 14px;
  }
  .booth-text {
    display: block;
  }
  .booth-badge {
    display: none; /* Hide booth on small mobile to save space */
  }
}
</style>
